import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useSelector } from "react-redux";
import { IEuCutOutProduct, OrderCategory, TApiOrderDetails } from "../../api/endpoints/Order";
import { paths } from "../../router";
import { fetchSets } from "../../store/action-creators/sets";
import { Button, Card, Col, Row } from "react-bootstrap";
import PageTitle from "../../components/Ui/PageTitle";
import EuCutOutConfigurator from "../../components/EuCutOutConfigurator";
import { fetchOrderDetails, updateOrder } from "../../store/action-creators/orders";
import { TRootState } from "../../store/reducers/RootReducer";
import { TOrdersByIdState } from "../../store/reducers/ordersById";
import LoadingIndicator from "../../components/Feedback/LoadingIndicator";
import useAppDispatch from "../../hooks/useAppDispatch";
import ButtonInverted from "../../components/Buttons/ButtonInverted";
import { IEuCutOutProductData, TOrderProduct } from "../../api/endpoints/OrderProduct";
import { Nullable } from "../../../types/utils";
import * as Api from "../../api";

const EuCutOutOrderEdit = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { orderId } = useParams<{ orderId: string }>();

  const orderState = useSelector<TRootState, TOrdersByIdState[string] | undefined>(store => store.ordersById[orderId])
  const order = orderState?.data;

  const [product, setProduct] = useState<Nullable<TOrderProduct<OrderCategory.EU_CUTOUT>>>(null);
  const [error, setError] = useState<Nullable<string>>(null)

  useEffect(() => {
    dispatch(fetchOrderDetails(orderId));
    dispatch(fetchSets());
  }, []);

  useEffect(() => {
    if (order) {
      Api.OrderProduct.list(order.id)
        .then(products => setProduct(products[0]))
        .catch(() => setError('Sorry! We were unable to fetch products.'));
    }
  }, [order]);

  const onProductUpdate = useCallback((productDataItems: Array<IEuCutOutProductData>) => {
    if (!product) {
      return;
    }

    Api.OrderProduct.update(product.order_id, product.id, productDataItems[0]).then(() => {
      history.push(paths.order(product.order_id));
    }).catch();
  }, [dispatch, history, product]);

  const onCancel = useCallback(() => {
    if (order) {
      history.push(paths.order(order.id));
    }
  }, [history, order])

  if (!order || orderState?.loading || !product) {
    return <LoadingIndicator />;
  }

  if (order.category !== OrderCategory.EU_CUTOUT) {
    return <div>Not found.</div>
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <PageTitle title="Configure European Cut-out" />
        </Col>
      </Row>

      <Card className="margin-bottom-sm">
        <Card.Body>
          <EuCutOutConfigurator
            product={product}
            onSubmit={onProductUpdate}
            actions={
              (products: Array<IEuCutOutProductData>, formik) => (
                <Fragment>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? 'Updating...' : 'Update'}
                  </Button>

                  <ButtonInverted onClick={onCancel} text="Cancel" />
                </Fragment>
              )
            }
          />
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default EuCutOutOrderEdit;
